import React from 'react';
import { useIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLink } from '@fortawesome/pro-light-svg-icons/faLink';
import { faMagnifyingGlass } from '@fortawesome/pro-light-svg-icons/faMagnifyingGlass';
import { TypedMemo } from '../../../common/types';
import { browseStateMessages as messages } from '../browseMessages';
/* eslint-disable css-modules/no-unused-class -- a shared stylesheet; each part uses its own slice of it */
import styles from './BrowseStates.module.scss';
/* eslint-enable css-modules/no-unused-class */

/** Example queries (design b1). LaziiBee is our own artist; the names are not translated. */
const TRY_QUERIES = ['LaziiBee', 'Swamps', 'Indie pop'];

interface BrowseTryChipsProps {
  onSearch: (query: string) => void;
  onPasteLink: () => void;
}

/** The "Try" chips: a chip fills the search box; the link chip opens the paste field. */
const BrowseTryChipsComponent: React.FC<BrowseTryChipsProps> = ({ onSearch, onPasteLink }) => {
  const intl = useIntl();
  return (
    <div className={styles.chips}>
      <span className={styles.chipLabel}>{intl.formatMessage(messages.tryTitle)}</span>
      {TRY_QUERIES.map((query) => (
        <button key={query} type="button" className={styles.chip} onClick={() => onSearch(query)}>
          <FontAwesomeIcon icon={faMagnifyingGlass} />
          {query}
        </button>
      ))}
      <button type="button" className={styles.chip} onClick={onPasteLink}>
        <FontAwesomeIcon icon={faLink} />
        {intl.formatMessage(messages.tryLink)}
      </button>
    </div>
  );
};

export const BrowseTryChips = TypedMemo(BrowseTryChipsComponent);
